import { waitForTransferringComponent } from './waitForTransferring.component';

export const waitForTransferringStateName = 'app.ticket.waitForTransferring';

export const waitForTransferringState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: 'app.ticket.waitForTransferring',
    url: '/waitForTransferring?upload',
    params: {
      upload: null
    },
    component: waitForTransferringComponent.name,
    data: { requiresAuth: true }
  });
};
